import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import ToastFavoriteDish from '@shopDetails/components/ToastFavoriteDish';
import MenuButton from '../MenuButton';

const Container = styled.div`
  top: ${({ theme }) => theme.spacing(2)};
  height: 40px;
  position: relative;
`;

const ContainerMenuButton = ({ onClickMenuOpen }) => {
  const targetRef = useRef();
  const [targetEl, setTargetEl] = useState(targetRef.current);

  useEffect(() => {
    setTargetEl(targetRef.current);
  }, [targetRef]);

  return (
    <>
      <Container ref={targetRef}>
        <MenuButton onClick={onClickMenuOpen} />
      </Container>
      <ToastFavoriteDish isMenuSection target={targetEl} />
    </>
  );
};

ContainerMenuButton.propTypes = {
  onClickMenuOpen: PropTypes.func.isRequired,
};

export default ContainerMenuButton;
